import axios from 'axios';

const url = process.env.VUE_APP_HOST;
const home = process.env.VUE_APP_HOME;

const getFormStyle = async function (){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

  //  if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`
        }
    };
    let urlWithArg = url + 'api/FormStyle';

    let result = await axios.get(urlWithArg, headers);
    
    return result.data;

}

export const formStyleService = { getFormStyle }


// WEBPACK FOOTER //
// ./src/api/form-style.service.js